import { CustomRequestOptions } from '@/interceptors/request'
import { useUserStore } from '@/store'
import { useI18n } from 'vue-i18n'
import i18n from '@/locales'

/**
 * 请求方法: 主要是对 uni.request 的封装，去适配 openapi-ts-request 的 request 方法
 * @param options 请求参数
 * @returns 返回 Promise 对象
 */
const http = <T>(options: CustomRequestOptions) => {
  // 1. 返回 Promise 对象
  return new Promise<T>((resolve, reject) => {
    // 使用 i18n 实例而不是 useI18n hook
    const { t } = i18n.global

    uni.request({
      timeout: 1000 * 60 * 5,
      ...options,
      dataType: 'json',
      // #ifndef MP-WEIXIN
      responseType: 'json',
      // #endif
      // 响应成功
      success(res: any) {
        console.log(`【http状态码：${res.statusCode}】${options.url}  => `, res.data)
        // 无401返回，临时方案监听message
        if (res.data.message === t('jwtRenZhengShiBaiTokenWuXiaoHuoYiGuoQi')) {
          const userStore = useUserStore()
          userStore.clearUserInfo()
          getApp().globalData.isEnterAccountDeletionReview = false
          uni.showToast({
            icon: 'none',
            title: t('dengLuShiXiaoQingZhongXinDengLu'),
            complete: () => {
              setTimeout(() => {
                // #ifdef H5 || APP-PLUS
                uni.reLaunch({ url: '/p-user/pages/login/login' })
                // #endif
                // #ifdef MP-WEIXIN
                uni.reLaunch({ url: '/p-user/pages/login/index' })
                // #endif
              }, 2000)
            },
          })
          reject(res)
        }
        // 状态码 2xx，参考 axios 的设计
        if (res.statusCode >= 200 && res.statusCode < 300) {
          // 2.1 提取核心数据 res.data
          resolve(res.data as T)
        } else if (res.statusCode === 401) {
          // 401错误  -> 清理用户信息，跳转到登录页
          // userStore.clearUserInfo()
          // uni.navigateTo({ url: '/p-user/pages/login/login' })
          reject(res)
        } else {
          // 其他错误 -> 根据后端错误信息轻提示
          !options.hideErrorToast &&
            uni.showToast({
              icon: 'none',
              title: (res.data as T & { msg?: string })?.msg || t('qingQiuCuoWu'),
            })
          reject(res)
        }
      },
      // 响应失败
      fail(err) {
        uni.showToast({
          icon: 'none',
          title: t('wangLuoCuoWuHuanGeWangLuoShiShi'),
        })
        reject(err)
      },
    })
  })
}

/*
 * openapi-ts-request 工具的 request 跨客户端适配方法
 */
export default function request(
  url: string,
  options: Omit<CustomRequestOptions, 'url'> & {
    params?: Record<string, unknown>
    headers?: Record<string, unknown>
  },
) {
  const requestOptions = {
    url,
    ...options,
  }

  if (options.params) {
    requestOptions.query = requestOptions.params
    delete requestOptions.params
  }

  if (options.headers) {
    requestOptions.header = options.headers
    delete requestOptions.headers
  }

  return http(requestOptions)
}
